import React from "react";
import { Container, Grid } from "@mui/material";
import Completion from "../../components/signup/completion";

const CompletionPage = () => {
  return (
    <Container fixed>
      <Grid
        container
        spacing={2}
        sx={{
          margin: 2,
        }}
      >
        <Grid
          sx={{
            backgroundColor: "primary.contrastText",
          }}
          item
          xs={12}
          md={12}
        >
          <Completion />
        </Grid>
      </Grid>
    </Container>
  );
};

export default CompletionPage;
